/* shared frame maths: used by the bag maker and the order page */
window.WNG=(function(){
  var NAMES={tt:'Top tube',dt:'Down tube',st:'Seat tube',ht:'Head tube'};
  /* "540", "54,5", "21.5", "21 1/2", "21-1/2", "1/2", with an optional unit. Empty gives null, anything else NaN. */
  function parseLen(str){
    var s=String(str==null?'':str).trim().toLowerCase().replace(/\s*(mm|inches|inch|in|"|″)$/,'').trim();
    if(!s)return null;
    /* "none" or "no gap" for a head tube where the tubes meet */
    if(/^(none|no gap|nil|zero)$/.test(s))return 0;
    s=s.replace(',','.');
    var m=/^(\d+(?:\.\d+)?)$/.exec(s);if(m)return parseFloat(m[1]);
    m=/^(\d+)[\s-]+(\d+)\/(\d+)$/.exec(s);if(m&&+m[3])return +m[1]+m[2]/m[3];
    m=/^(\d+)\/(\d+)$/.exec(s);if(m&&+m[2])return m[1]/m[2];
    return NaN;
  }
  function fmt(mm,inch){return inch?String(Math.round(mm/25.4*100)/100):String(Math.round(mm*10)/10)}
  /* A frame is not a pure triangle: the head tube sits between the top tube and the down tube.
     Seat cluster A=(0,0), top tube to B=(T,0), the head tube gap from B to B2, down tube B2 to C, seat tube A to C.
     H is the measured gap along the head tube between the top tube and the down tube; without it the gap is estimated. */
  function solve(T,D,S,H){
    var h=H>=0&&H!==null&&H!==undefined&&H!==''?Math.max(12,+H):Math.max(40,Math.min(170,0.55*S-190)),a=72*Math.PI/180;
    var bx=T+h*Math.cos(a),by=-h*Math.sin(a),d=Math.sqrt(bx*bx+by*by);
    if(d>=S+D||d<=Math.abs(S-D))return null;
    var k=(S*S-D*D+d*d)/(2*d),hh=Math.sqrt(Math.max(S*S-k*k,0)),px=k*bx/d,py=k*by/d;
    var c1=[px+hh*by/d,py-hh*bx/d],c2=[px-hh*by/d,py+hh*bx/d],C=c1[1]<c2[1]?c1:c2;
    return {A:[0,0],B:[T,0],B2:[bx,by],C:C,head:h,angle:Math.atan2(-C[1],C[0])*180/Math.PI};
  }
  var LIM={tt:[300,900],dt:[300,1100],st:[150,900],ht:[0,300]};
  function range(k,v,inch){
    if(v>=LIM[k][0]&&v<=LIM[k][1])return '';
    return NAMES[k]+': '+fmt(v,inch)+(inch?' in':' mm')+' looks too '+(v<LIM[k][0]?'short':'long')+' for a bike frame. Check the number and the unit.';
  }
  function check(t,d,s,inch,h){
    var v={tt:t,dt:d,st:s,ht:h},keys=['tt','dt','st','ht'];
    for(var i=0;i<4;i++){if(keys[i]==='ht'&&(h===undefined||h===null))continue;var m=range(keys[i],v[keys[i]],inch);if(m)return {ok:false,field:keys[i],msg:m}}
    var g=solve(t,d,s,h);
    if(!g)return {ok:false,field:null,msg:'Those lengths do not fit together as a frame. Measure each one again, along the inside of the tube.'};
    if(g.angle<58||g.angle>100||g.C[1]>-140)return {ok:false,field:null,odd:true,msg:'This preview cannot draw that frame shape. It may be a full-suspension or unusual frame. We can still make the bag: continue to order and send a side-on photo.'};
    return {ok:true,geo:g};
  }
  return {parseLen:parseLen,fmt:fmt,solve:solve,check:check,range:range,NAMES:NAMES};
})();
WNG.STYLES=['Half Frame Bag - 2 Pocket','Full Frame Bag - 2 Pocket','Full Frame Bag - 3 Pocket'];
WNG.FABRICS=['600denier Poly (Standard)','1000denier Cordura','Ecopak™ EPX200'];
/* old indexes stay put so designs saved before a colour change still read right; only the colours a fabric offers are shown */
WNG.COLOURS=[['Fuchsia','#A8146F'],['Hot pink','#EC2F72'],['Red','#B3141F'],['Orange','#E2561B'],['Gold','#D99A14'],['Yellow','#DDBB10'],['Teal','#06A3B8'],['Purple','#33307A'],['Navy','#16233A'],['Emerald','#0F6B5C'],['Forest','#17463A'],['Mustard','#B8842A'],['Tan','#B5793F'],['Burgundy','#7A2B3C'],['Slate','#4A4B57'],['Black','#1B1B20'],['Jade','#1E9E7A'],['White','#F1F1EC'],['Grey','#8A8D8F'],['Camo','#6F7651']];
WNG.CAMO=19;
WNG.swatch=function(j){return j===WNG.CAMO?'linear-gradient(135deg,#B3A482 0 33%,#6F7651 33% 66%,#4E4030 66%)':WNG.COLOURS[j][1]};
WNG.PATCHES=['Woven patch','Leather patch','One-colour print'];
/* colours each fabric comes in, from the theme setting "Colours per fabric": one line per fabric, "Cordura: Black, Camo, Red" */
WNG.offered=(function(){
  var cache=null,ALIAS={fuschia:'fuchsia',gray:'grey',multicam:'camo'};
  function key(t){return String(t).toLowerCase().replace(/[™®]/g,'').replace(/\s+/g,' ').trim()}
  function parse(){
    var out=WNG.FABRICS.map(function(){return []});
    String(window.WNG_COLOURS||'').split(/\n/).forEach(function(line){
      var at=line.indexOf(':');if(at<0)return;
      var name=key(line.slice(0,at));if(!name)return;
      WNG.FABRICS.forEach(function(f,fi){
        if(key(f).indexOf(name)<0)return;
        line.slice(at+1).split(',').forEach(function(c){
          var n=key(c);n=ALIAS[n]||n;
          for(var j=0;j<WNG.COLOURS.length;j++)if(key(WNG.COLOURS[j][0])===n&&out[fi].indexOf(j)<0)out[fi].push(j);
        });
      });
    });
    /* a fabric with no line, or a line with no known colours, offers the full list */
    return out.map(function(l){return l.length?l:WNG.COLOURS.map(function(c,j){return j}).filter(function(j){return j!==WNG.CAMO})});
  }
  return function(fi){if(!cache)cache=parse();return cache[fi]||cache[0]};
})();
/* the zip cover is a colour that stands out from the two panels the zip runs between: never teal on teal */
WNG.zipChoices=function(cols,fi){var a=WNG.offered(fi);return a.filter(function(j){return j!==cols[0]&&j!==cols[1]})};
/* swap any colour the fabric does not come in, and keep the zip cover off its panels. Returns plain-text notes of what changed. */
WNG.fitColours=function(cols,style,fi){
  var a=WNG.offered(fi),notes=[],names=['Top panel','Middle panel','Bottom panel'];
  for(var i=0;i<3;i++){
    if(a.indexOf(cols[i])>=0)continue;
    var was=WNG.COLOURS[cols[i]]?WNG.COLOURS[cols[i]][0]:'',pick=a.filter(function(j){return cols.slice(0,3).indexOf(j)<0})[0];
    cols[i]=pick===undefined?a[0]:pick;
    if(was&&!(style===0&&i===2))notes.push(names[i]+': '+was+' changed to '+WNG.COLOURS[cols[i]][0]);
  }
  var z=WNG.zipChoices(cols,fi);
  if(z.indexOf(cols[3])<0){
    var wasZ=WNG.COLOURS[cols[3]]?WNG.COLOURS[cols[3]][0]:'';
    /* the bag's own third colour first, as Steven does it */
    cols[3]=(style!==0&&z.indexOf(cols[2])>=0)?cols[2]:(z[0]!==undefined?z[0]:a[0]);
    if(wasZ)notes.push('Zip cover: '+wasZ+' changed to '+WNG.COLOURS[cols[3]][0]);
  }
  return notes;
};
/* the design saved by the bag maker on this device, or null */
WNG.design=function(){
  var d=null;try{d=JSON.parse(localStorage.getItem('wng-design')||'null')}catch(x){}
  function okI(v,max){return typeof v==='number'&&v%1===0&&v>=0&&v<=max}
  var top=WNG.COLOURS.length-1;
  if(!d||!Array.isArray(d.cols)||d.cols.length<3||!d.cols.every(function(c){return okI(c,top)})||!okI(d.style,2)||!okI(d.fabric,4))return null;
  if(d.fabric>WNG.FABRICS.length-1)d.fabric=0;
  if(d.cols.length<4)d.cols[3]=15;
  d.mode=okI(d.mode,2)?d.mode:0;d.patch=okI(d.patch,2)?d.patch:0;
  d.note=Array.isArray(d.note)?[String(d.note[0]||'').slice(0,200),String(d.note[1]||'').slice(0,600)]:['',''];
  if(d.frame&&!(d.frame.tt>0&&d.frame.dt>0&&d.frame.st>0))d.own=false;
  return d;
};
/* plain-text lines describing a saved design */
WNG.designLines=function(d,styleIdx,fabricIdx){
  var half=styleIdx===0,out=[];
  function row(n,j){return [n,WNG.COLOURS[j][0],j===WNG.CAMO?'camo':WNG.COLOURS[j][1]]}
  if(d.mode===1){out.push(['Colours','Surprise me, chosen by the workshop']);if(d.note[0].trim())out.push(['Colours to use or avoid',d.note[0].trim()])}
  else{
    ['Top panel','Middle panel','Bottom panel'].forEach(function(n,i){if(half&&i===2)return;out.push(row(n,d.cols[i]))});
    if(d.cols[3]!=null)out.push(row('Zip cover',d.cols[3]));
  }
  out.push(['Patch',WNG.PATCHES[d.patch]]);
  if(d.mode===2)out.push(['Custom design',d.note[1].trim()||'not described yet']);
  return out;
};
(function(){
  var $=function(id){return document.getElementById(id)};
  /* colourway buttons recolour every pattern piece on the page */
  var cws=document.querySelectorAll('.cw'),ways=document.querySelectorAll('.way');
  ways.forEach(function(b){
    b.addEventListener('click',function(){
      var c=b.getAttribute('data-c').split(',');
      cws.forEach(function(el){c.forEach(function(v,i){el.style.setProperty('--c'+i,v)})});
      ways.forEach(function(o){o.setAttribute('aria-pressed',o===b?'true':'false')});
      if(!$('maker'))try{localStorage.setItem('wng-way',b.getAttribute('data-c'))}catch(x){}
    });
  });
  /* a gallery photo starts the bag maker in that bag's colours */
  /* only offered while the workshop has those colours in one fabric */
  document.querySelectorAll('.like').forEach(function(a){
    var js=a.getAttribute('data-c').split(',').slice(0,3).map(function(h){for(var j=0;j<WNG.COLOURS.length;j++)if(WNG.COLOURS[j][1].toLowerCase()===h.trim().toLowerCase())return j;return -1});
    a.hidden=!WNG.FABRICS.some(function(f,fi){var o=WNG.offered(fi);return js.every(function(j){return o.indexOf(j)>=0})});
    a.addEventListener('click',function(){try{localStorage.setItem('wng-way',a.getAttribute('data-c'))}catch(x){}});
  });
  /* phones: keep a buy button on screen whenever the main one is not, until the newsletter band */
  var bar=$('buybar'),cta=$('hero-cta');
  if(bar&&cta&&'IntersectionObserver' in window){
    document.body.classList.add('has-buybar');
    var past=false,end=false,foot=document.querySelector('.join');
    var show=function(){bar.hidden=!(past&&!end)};
    new IntersectionObserver(function(e){past=!e[0].isIntersecting;show()}).observe(cta);
    if(foot)new IntersectionObserver(function(e){end=e[0].isIntersecting;show()}).observe(foot);
  }
  /* product photos: thumbnails swap the main photo */
  document.querySelectorAll('.thumbs button').forEach(function(b){
    b.addEventListener('click',function(){
      var img=$('shot');if(!img)return;
      img.src=b.getAttribute('data-src');img.srcset='';img.alt=b.getAttribute('data-alt')||'';
      document.querySelectorAll('.thumbs button').forEach(function(o){o.setAttribute('aria-pressed',o===b?'true':'false')});
    });
  });

  /* ---------- product forms: pick the variant from the chosen options ---------- */
  document.querySelectorAll('form[data-pf]').forEach(function(form){
    var data=JSON.parse(form.querySelector('script[data-variants]').textContent);
    var idIn=form.querySelector('input[name="id"]'),out=form.querySelector('[data-price]'),btn=form.querySelector('[data-add]');
    var label=btn.getAttribute('data-label')||btn.textContent,groups=form.querySelectorAll('[data-opt]');
    function chosen(){var o=[];groups.forEach(function(g){var c=g.querySelector('input:checked');o.push(c?c.value:null)});return o}
    function find(opts){for(var i=0;i<data.length;i++){var v=data[i],ok=true;for(var k=0;k<opts.length;k++)if(v.options[k]!==opts[k])ok=false;if(ok)return v}return null}
    form.wngVariant=function(){return groups.length?find(chosen()):data[0]};
    form.wngFind=find;form.wngChosen=chosen;
    var stock=form.querySelector('[data-stock]');
    form.wngUpdate=function(){
      var v=form.wngVariant();
      /* finished items: say how many are left once it is three or fewer */
      if(stock)stock.textContent=(v&&v.available&&v.qty!==null&&v.qty!==undefined&&v.qty>0)?(v.qty<=3?v.qty+' in stock':'In stock'):'';
      if(v){idIn.value=v.id;if(out)out.textContent=v.money;btn.disabled=!v.available;btn.textContent=v.available?(form.wngLabel||label):'Sold out'}
      else{btn.disabled=true;btn.textContent='Not available'}
    };
    form.addEventListener('change',form.wngUpdate);form.wngUpdate();
  });

  /* ---------- the frame bag order form ---------- */
  var buy=$('buy');
  if(buy&&buy.hasAttribute('data-frame-bag')){
    var styleG=buy.querySelector('[data-opt="Style"]'),fabricG=buy.querySelector('[data-opt="Fabric"]');
    function pick(group,value){if(!group)return;group.querySelectorAll('input').forEach(function(i){if(i.value===value)i.checked=true})}
    function idx(list,group){var c=group&&group.querySelector('input:checked');return c?list.indexOf(c.value):-1}
    var hash={half:0,full2:1,full3:2}[location.hash.slice(1)];
    var design=WNG.design();
    /* the colours as chosen in the maker, so switching fabric here and back restores them */
    var origCols=design?design.cols.slice():null;
    if(design){pick(styleG,WNG.STYLES[hash!==undefined?hash:design.style]);pick(fabricG,WNG.FABRICS[design.fabric])}
    else if(hash!==undefined)pick(styleG,WNG.STYLES[hash]);
    if(design&&design.own&&design.frame){
      var inch0=design.unit==='in';$(inch0?'u-in':'u-mm').checked=true;
      [['tt','tt'],['dt','dt'],['stube','st'],['htube','ht']].forEach(function(p){if(design.frame[p[1]]>=0&&design.frame[p[1]]!==null)buy.elements[p[0]].value=WNG.fmt(design.frame[p[1]],inch0)});
    }
    var list=$('dz-list'),props=$('dz-props'),custom=false;
    /* fabrics are listed in the same order as the bag maker */
    if(fabricG){
      WNG.FABRICS.forEach(function(name){fabricG.querySelectorAll('label').forEach(function(l){if(l.querySelector('input').value===name)fabricG.appendChild(l)})});
      /* fabrics still on the product but not offered any more are left out */
      fabricG.querySelectorAll('label').forEach(function(l){var i=l.querySelector('input');if(WNG.FABRICS.indexOf(i.value)<0){if(i.checked){i.checked=false;var f=fabricG.querySelector('input[value="'+WNG.FABRICS[0].replace(/"/g,'\\"')+'"]');if(f)f.checked=true}l.remove()}});
    }
    /* the style pictures take the colours chosen in the bag maker */
    function tint(){if(design&&design.mode===0&&styleG)design.cols.slice(0,3).forEach(function(c,i){if(WNG.COLOURS[c])styleG.style.setProperty('--c'+i,WNG.COLOURS[c][1])})}
    /* fabric chips show the price difference from the standard fabric for the chosen style */
    function deltas(){
      if(!styleG||!fabricG)return;
      var s=styleG.querySelector('input:checked').value,base=null,labels=fabricG.querySelectorAll('label');
      labels.forEach(function(l){var f=l.querySelector('input').value,v=buy.wngFind([s,f]);if(v&&(base===null||v.price<base))base=v.price});
      labels.forEach(function(l){var f=l.querySelector('input').value,v=buy.wngFind([s,f]),sm=l.querySelector('small');if(sm)sm.textContent=(v&&v.price>base)?'+$'+Math.round((v.price-base)/100):''});
    }
    function showDesign(){
      deltas();
      if(!design)return;
      var si=idx(WNG.STYLES,styleG),fi=idx(WNG.FABRICS,fabricG);
      if(si<0)si=design.style;if(fi<0)fi=design.fabric;
      /* a fabric picked here may not come in the colours chosen in the maker */
      design.cols=origCols.slice();
      var changed=design.mode===2?[]:WNG.fitColours(design.cols,si,fi),dn=$('dz-note');
      if(dn){dn.hidden=!changed.length;dn.textContent=changed.length?'Not available in this fabric, so we changed it: '+changed.join('. ')+'.':''}
      tint();
      list.textContent='';props.textContent='';
      WNG.designLines(design,si,fi).forEach(function(r){
        var li=document.createElement('li');
        if(r[2]){var sw=document.createElement('i');if(r[2]==='camo')sw.className='camo';else sw.style.background=r[2];li.appendChild(sw)}
        li.appendChild(document.createTextNode(r[0]+': '+r[1]));list.appendChild(li);
        var h=document.createElement('input');h.type='hidden';h.name='properties['+r[0]+']';h.value=r[1];props.appendChild(h);
      });
      custom=design.mode===2;
      $('buy-quote').hidden=!custom;if($('buy-lead'))$('buy-lead').hidden=custom;buy.wngLabel=custom?'Request a quote':null;buy.wngUpdate();
      design.style=si;design.fabric=fi;
      try{localStorage.setItem('wng-design',JSON.stringify(design))}catch(x){}
      showRender(si,fi);
    }
    /* the picture made in the bag maker: shown here and sent with the order, as long as it still matches the choices */
    function showRender(si,fi){
      var img=$('dz-img'),file=$('dz-file'),r=null,bk=$('dz-bike'),s=null;
      /* the bike from See it on your bike, while it still shows these choices */
      if(bk){
        try{s=JSON.parse(localStorage.getItem('wng-nbshot')||'null')}catch(x){}
        var same=!!s&&!!s.img&&Date.now()-s.t<7*864e5&&design.mode===0&&s.style===si&&String(s.cols)===String(design.cols.slice(0,4)),bi=bk.querySelector('img');
        if(same&&bi.getAttribute('src')!==s.img)bi.src=s.img;bk.hidden=!same;
      }
      if(!img||!file)return;
      try{r=JSON.parse(localStorage.getItem('wng-render')||'null')}catch(x){}
      var ok=r&&r.img&&design.mode===0&&r.style===si&&r.fabric===fi&&r.patch===design.patch&&String(r.cols)===String(design.cols);
      img.hidden=!ok;
      if(!ok){file.value='';return}
      if(img.getAttribute('src')===r.img)return;
      img.src=r.img;
      try{
        var bin=atob(r.img.split(',')[1]),buf=new Uint8Array(bin.length);for(var i=0;i<bin.length;i++)buf[i]=bin.charCodeAt(i);
        var dt=new DataTransfer();dt.items.add(new File([buf],'bag-design.jpg',{type:'image/jpeg'}));file.files=dt.files;
      }catch(x){}
    }
    if(design){$('dz-empty').hidden=true;$('dz').hidden=false}
    buy.addEventListener('change',showDesign);showDesign();buy.wngUpdate();
    var addons=buy.querySelectorAll('input[data-addon-id]'),out=buy.querySelector('[data-price]');
    function picked(){return [].filter.call(addons,function(a){return a.checked})}
    function addonTotal(){
      if(!addons.length||!out)return;
      var v=buy.wngVariant(),extra=0;if(!v)return;
      var off=0;picked().forEach(function(a){extra+=Number(a.getAttribute('data-addon-price'));off=Math.max(off,Number(a.getAttribute('data-addon-off'))||0)});extra-=off;
      if(extra)out.textContent=v.money.replace(/[\d.,]+/,((v.price+extra)/100).toFixed(2));
    }
    if(addons.length){buy.addEventListener('change',function(){buy.wngUpdate();addonTotal()});addonTotal()}
    /* switching units converts what is typed instead of reading it as the other unit */
    var unitNow=buy.elements.unit.value;
    buy.addEventListener('change',function(e){
      if(e.target.name!=='unit'||e.target.value===unitNow)return;
      var toIn=e.target.value==='in';unitNow=e.target.value;
      ['tt','dt','stube','htube'].forEach(function(k){var v=WNG.parseLen(buy.elements[k].value);if(v>0)buy.elements[k].value=WNG.fmt(toIn?v:v*25.4,toIn)});
    });
    /* what is typed about the bike is kept on this device, so a reload or a trip back to the bag maker does not lose it */
    var KEEP=['make','model','year','tt','dt','stube','htube'],kept=null;
    try{kept=JSON.parse(localStorage.getItem('wng-bike')||'null')}catch(x){}
    if(kept){
      if(kept.unit==='in'&&!(design&&design.own)){$('u-in').checked=true;unitNow='in'}
      KEEP.forEach(function(k){if(kept[k]&&!buy.elements[k].value)buy.elements[k].value=kept[k]});
    }
    function keep(){var o={unit:buy.elements.unit.value};KEEP.forEach(function(k){o[k]=buy.elements[k].value});try{localStorage.setItem('wng-bike',JSON.stringify(o))}catch(x){}}
    buy.addEventListener('input',keep);buy.addEventListener('change',keep);
    function busy(){var b=buy.querySelector('[data-add]');if(!b)return;b.disabled=true;b.setAttribute('aria-busy','true');b.textContent='Adding to cart';buy.classList.add('busy')}
    window.addEventListener('pageshow',function(e){if(!e.persisted)return;buy.wngAddonDone=false;buy.classList.remove('busy');var b=buy.querySelector('[data-add]');if(b)b.removeAttribute('aria-busy');buy.wngUpdate();addonTotal()});
    buy.addEventListener('submit',function(e){
      var names={make:'the make of your bike',model:'the model',year:'the year',tt:'the top tube length',dt:'the down tube length',stube:'the seat tube length',htube:'the head tube gap (0 if the tubes meet)'};
      /* all four lengths are needed; a head tube with no gap is 0 */
      var missing=[],first=null,notes=[],inch=buy.elements.unit.value==='in',lens={},mm={};
      Object.keys(names).forEach(function(k){
        var f=buy.elements[k],v=f.value.trim(),len=(k==='tt'||k==='dt'||k==='stube'||k==='htube'),bad=!v;
        if(len&&v){
          var n=WNG.parseLen(v),key=k==='stube'?'st':k==='htube'?'ht':k;
          /* tubes that meet at the head tube leave no gap, so 0 is a real answer there */
          if(!(n>0||(k==='htube'&&n===0))){bad=true;var eg='Use numbers only for the tube lengths, like '+(inch?'21.5 or 21 1/2':'540')+'.';if(notes.indexOf(eg)<0)notes.push(eg)}
          else{var m=WNG.range(key,inch?n*25.4:n,inch);if(m){bad=true;notes.push(m)}else{lens[k]=WNG.fmt(inch?n*25.4:n,inch)+(inch?' in':' mm');mm[k]=inch?n*25.4:n}}
        }
        f.setAttribute('aria-invalid',bad?'true':'false');
        if(bad){if(!v)missing.push(names[k]);if(!first)first=f}
      });
      /* the same shape check as the bag maker: three lengths that cannot meet are a typing or measuring slip. An unusual frame still goes through, the photo settles it. */
      if(mm.tt&&mm.dt&&mm.stube){
        var c=WNG.check(mm.tt,mm.dt,mm.stube,inch,mm.htube);
        if(!c.ok&&!c.odd){notes.push(c.msg);['tt','dt','stube','htube'].forEach(function(k){buy.elements[k].setAttribute('aria-invalid','true')});if(!first)first=buy.elements.tt}
      }
      var err=$('buy-err');
      if(missing.length||notes.length){
        e.preventDefault();
        err.textContent=(missing.length?'We need '+missing.join(', ')+' before we can make your bag. ':'')+notes.join(' ');
        $('bike').scrollIntoView({block:'start',behavior:'smooth'});
        try{first.focus({preventScroll:true})}catch(x){first.focus()}
        return;
      }
      err.textContent='';
      $('p-tt').value=lens.tt;$('p-dt').value=lens.dt;$('p-st').value=lens.stube;$('p-ht').value=lens.htube;
      /* the add-on goes into the cart first, then the bag is added by the normal form post so the photo upload still works */
      var extras=picked();
      if(!custom&&extras.length&&!buy.wngAddonDone){
        e.preventDefault();
        busy();
        var send=function(){buy.wngAddonDone=true;buy.submit()};
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:extras.map(function(a){var i={id:Number(a.getAttribute('data-addon-id')),quantity:1},m=a.getAttribute('data-addon-match');if(m)i.properties={Colours:m};return i})})}).then(send,send);
        return;
      }
      if(custom){
        /* a custom design is quoted first, so it goes to the workshop as a message instead of the cart */
        e.preventDefault();
        var v=buy.wngVariant(),lines=['Frame bag, custom design'];
        if(v)lines.push('Style and fabric: '+v.options.join(', '));
        WNG.designLines(design,design.style,design.fabric).forEach(function(r){lines.push(r[0]+': '+r[1])});
        lines.push('Bike: '+[buy.elements.make.value,buy.elements.model.value,buy.elements.year.value].join(' ').trim());
        lines.push('Inside lengths: top tube '+lens.tt+', down tube '+lens.dt+', seat tube '+lens.stube+', head tube '+lens.htube);
        try{sessionStorage.setItem('wng-quote',lines.join('\n'))}catch(x){}
        location.href=buy.getAttribute('data-quote-url');
        return;
      }
      /* a photo can take a while to upload on a phone, so the button says what is happening */
      setTimeout(busy,0);
    });
  }
  /* the custom work form picks up a frame bag quote request */
  var idea=$('e-idea');
  if(idea){
    var q=null;try{q=sessionStorage.getItem('wng-quote')}catch(x){}
    if(q&&!idea.value){idea.value=q;try{sessionStorage.removeItem('wng-quote')}catch(x){}var qn=$('quote-note');if(qn)qn.hidden=false;
      /* photos above the form load late and push it down, so go to it again once the page has settled */
      var toForm=function(){var s=$('enquire');if(s)s.scrollIntoView({block:'start',behavior:'instant'})};toForm();window.addEventListener('load',toForm)}
  }
})();
/* order page: offer the photo taken on "See it on your bike" as the bike photo. It only leaves the phone if the box stays ticked and they order. */
(function(){
  var input=document.getElementById('photo'),hint=document.getElementById('photo-hint'),r=null;
  if(!input||!hint||!window.DataTransfer)return;
  try{r=JSON.parse(localStorage.getItem('wng-bikephoto')||'null')}catch(x){}
  if(!r||!r.img||!(Date.now()-r.t<7*864e5))return;
  var file;
  try{var bin=atob(r.img.split(',')[1]),buf=new Uint8Array(bin.length);for(var i=0;i<bin.length;i++)buf[i]=bin.charCodeAt(i);file=new File([buf],'bike-photo.jpg',{type:'image/jpeg'})}catch(x){return}
  var box=document.createElement('label');box.className='kept-photo';
  /* offered, not ticked: the photo page promises the photo is only sent if they add it */
  box.innerHTML='<input type="checkbox"><img alt="" width="96" height="72"><span>Add your bike photo</span>';
  var tick=box.querySelector('input');box.querySelector('img').src=r.img;
  function apply(){if(tick.checked){var dt=new DataTransfer();dt.items.add(file);input.files=dt.files}else input.value=''}
  tick.addEventListener('change',apply);
  input.addEventListener('change',function(){if(input.files.length&&input.files[0]!==file){tick.checked=false;box.hidden=true}});
  hint.parentNode.insertBefore(box,hint.nextSibling);
})();
